var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ejs-button',{attrs:{"disabled":_vm.disabled,"cssClass":_vm.cssClass},nativeOn:{"click":function($event){return _vm.downloadResult.apply(null, arguments)}}},[_vm._v(_vm._s(this.$ts('MCS.downloadResult')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }